import React from "react";
import { useEffect, useState } from "react";
import Option from "../../Models/forms/Option";
import axiosApi from "../Api/Axios";
import BackendServices from "../Api/BackendService";
import SearchableDropdown from "../SearchableDropdown";
import axios from "axios";

interface NatureOfBusinessSelectorProps {
  readonly disabled?: boolean;
  readonly value: Option | null;
  readonly onChange: (val: Option | null) => void;
  readonly required?: boolean;
  readonly className?: string;
  readonly label?: string;
}

const NatureOfBusinessSelector = ({
    disabled,
    value,
    onChange,
    required,
    className,
    label
}:NatureOfBusinessSelectorProps) => {
    const [options, setOptions] = useState<Option[]>([]);
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_AXIOS_API}${BackendServices.COMPANY_SERVICE}/NatureOfBusiness`)
        .then(({data}) => {
            const businessOptions: Option[] = data.map((bp: any)=> ({
                label: bp.name ?? "",
                value: bp.id
            }))
            setOptions(businessOptions);
        })
        .catch(error => console.log(error))
    },[])

    return (
        <SearchableDropdown
        disabled={disabled}
      value={value}
      required={required}
      name="natureSelector"
      Options={options}
      label={label ?? "Nature of Business"}
      onChange={(e, newValue) => onChange(newValue)}
      className={className}
    />
    )
}

export default NatureOfBusinessSelector